import { render, staticRenderFns } from "./ChangeStatusClientsList.vue?vue&type=template&id=5b197300&"
import script from "./ChangeStatusClientsList.vue?vue&type=script&lang=js&"
export * from "./ChangeStatusClientsList.vue?vue&type=script&lang=js&"
import style0 from "./ChangeStatusClientsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports